import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import * as Yup from "yup";

// const validationSchema = Yup.object({
//   name: Yup.string()
//     .trim()
//     .min(2, "Size name must be at least 2 characters")
//     .required("Size name is required"),

//   value: Yup.string()
//     .trim()
//     .required("Size value is required"),

//   status: Yup.string()
//     .required("Status is required")
//     .oneOf(["ACTIVE", "INACTIVE"]),
// });

export default function SizeForm({
  initialValues,
  onSubmit,
  backendErrors = {},
  loading = false,
  buttonText = "Submit",
}) {
  const [formData, setFormData] = useState({
    name: "",
    value: "",
    status: "ACTIVE",
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    if (initialValues) {
      setFormData({
        name: initialValues.name || "",
        value: initialValues.value || "",
        status: initialValues.status || "ACTIVE",
      });
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // await validationSchema.validate(formData, {
      //   abortEarly: false,
      // });

      setErrors({});
      onSubmit(formData);
    } catch (validationError) {
      const newErrors = {};

      validationError.inner.forEach((err) => {
        newErrors[err.path] = err.message;
      });

      setErrors(newErrors);
    }
  };

  return (
    <div className="">
      <form onSubmit={handleSubmit}>
        <div className="row g-1">
          <div className="col-md-6 h80">
            <label className="form-label">
              Size Name<span className="error">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                errors.name || backendErrors?.name ? "is-invalid" : ""
              }`}
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {errors.name && (
              <div className="invalid-feedback">{errors.name}</div>
            )}
            {!errors.name && backendErrors?.name && (
              <div className="invalid-feedback d-block error">
                {backendErrors.name}
              </div>
            )}
          </div>

          <div className="col-md-6 h80">
            <label className="form-label">
              Size Value<span className="error">*</span>
            </label>
            <input
              type="text"
              className={`form-control ${
                errors.value || backendErrors?.value ? "is-invalid" : ""
              }`}
              name="value"
              value={formData.value}
              onChange={handleChange}
            />
            {errors.value && (
              <div className="invalid-feedback">{errors.value}</div>
            )}
            {!errors.value && backendErrors?.value && (
              <div className="invalid-feedback d-block error">
                {backendErrors.value}
              </div>
            )}
          </div>

          <div className="col-md-6 h80">
            <label className="form-label">
              Status<span className="error">*</span>
            </label>
            <select
              className={`form-select ${
                errors.status || backendErrors?.status ? "is-invalid" : ""
              }`}
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="ACTIVE">Active</option>
              <option value="INACTIVE">Inactive</option>
            </select>

            {errors.status && (
              <div className="invalid-feedback">{errors.status}</div>
            )}
            {!errors.status && backendErrors?.status && (
              <div className="invalid-feedback d-block error">
                {backendErrors.status}
              </div>
            )}
          </div>

          <div className="col-12 d-flex justify-content-end gap-2">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading ? "Loading..." : buttonText}
            </button>

            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => navigate("/Size")}
            >
              Cancel
            </button>   
          </div>
        </div>
      </form>
    </div>
  );
}
